export const DeleteIcon = () => <>&#10006;</>;